import {
    CREATE_PRESCRIPTION_DRAFT,
    EWUS_VERIFICATION,
    getDraftPrescriptionSetExistsEndpoint,
    getMedicationPackList,
    getPrescriptionDraftEndpoint,
    getPrescriptionPdfEndpoint,
    getPrescriptionsEndpoint,
    ISSUE_PRESCRIPTION,
    MEDICINAL_PRODUCT_LIST,
    PRESCRIPTION_HISTORY,
} from './prescriptionsEndpoints';
import {P1Service, rawP1Service} from '../../services/P1Service';
import {
    CreatePrescriptionDraftDto,
    IssuePrescriptionDto,
    MedicationPackDto,
    MedicinalProductDto,
    PatientPrescriptionHistoryDto,
    PatientPrescriptionHistoryPayload,
    PrescriptionSetDto,
    IssuePrescriptionResponse,
} from '../../types/prescription';
import {P1Response, P1ResponseWithPagination} from '../../types/p1Service';
import {EwusVerificationResultDto} from '../../types/ewus';

class PrescriptionApi {
    getMedicinalProductList(search: string) {
        return P1Service.get<P1Response<MedicinalProductDto[]>>(
            MEDICINAL_PRODUCT_LIST,
            {
                params: {search},
            },
        );
    }
    getMedicationPackList(medicinalProductId: number) {
        return P1Service.get<P1Response<MedicationPackDto[]>>(
            getMedicationPackList(medicinalProductId),
        );
    }
    issuePrescription(prescription: IssuePrescriptionDto, sourceDraftId?: string) {
        if(sourceDraftId) 
            return P1Service.post<P1Response<IssuePrescriptionResponse>>(
            ISSUE_PRESCRIPTION + `?sourceDraftId=${sourceDraftId}`,
            prescription,
        );
        
        return P1Service.post<P1Response<IssuePrescriptionResponse>>(
            ISSUE_PRESCRIPTION,
            prescription,
        );
    }
    getPrescriptionsForAppointment(appointmentId: number) {
        return rawP1Service.get<P1Response<PrescriptionSetDto[]>>(
            getPrescriptionsEndpoint(appointmentId),
        );
    }
    getPrescriptionPdf(prescriptionSetId: string) {
        return rawP1Service.get<string>(
            getPrescriptionPdfEndpoint(prescriptionSetId),
        );
    }
    getPatientPrescriptionHistory(
        appointmentData: PatientPrescriptionHistoryPayload,
    ) {
        return P1Service.post<
            P1ResponseWithPagination<PatientPrescriptionHistoryDto>
        >(PRESCRIPTION_HISTORY, appointmentData);
    }
    getPrescriptionSetDraftExists(appointmentId: number) {
        return P1Service.get<P1Response<boolean>>(
            getDraftPrescriptionSetExistsEndpoint(appointmentId),
        );
    }
    createPrescriptionDraft(prescriptionDraftDto: CreatePrescriptionDraftDto) {
        return P1Service.post<P1Response<string>>(CREATE_PRESCRIPTION_DRAFT, prescriptionDraftDto);
    }

    getPrescriptionDraft(appointmentId: number) {
        return P1Service.get<P1Response<PrescriptionSetDto>>(getPrescriptionDraftEndpoint(appointmentId));
    }

}

export default new PrescriptionApi();
